import { useCallback, useEffect, useRef } from "react";
import {
  useBeforeUnload,
  unstable_useBlocker as useBlocker,
} from "react-router-dom";

export function useUnsavedChangesPrompt({ showPrompt = true, stepLinks = [] }) {

    const onLocationChange = useCallback(
    ({ nextLocation }) => {
      if (
        !stepLinks.some((link) => nextLocation.pathname.startsWith(link)) &&
        showPrompt
      ) {
        return !window.confirm(
          "Watch out! You tried to leave without saving or sending the form. All data will be lost. Are you sure to quit?"
        );
      }
      return false;
    },
    [showPrompt, ...stepLinks]
  );

  const blocker = useBlocker(showPrompt ? onLocationChange : false);
  const prevState = useRef(blocker.state);

  useEffect(() => {
    if (blocker.state === "blocked") {
      blocker.reset();
    }
    prevState.current = blocker.state;
  }, [blocker]);

  useBeforeUnload(
    useCallback(
      (event) => {
        if (showPrompt)
          return (event.returnValue =
            "Watch out! You tried to leave without saving or sending the form. All data will be lost. Are you sure to quit?");
      },
      [showPrompt]
    ),
    { capture: true }
  );
}
